<template>
  <div>
    <div class="wrap">
      <div class="nope" v-if="!scans.length">Сканов нет</div>

      <div class="space-y-3 scans" v-else>
        <div class="scan" v-for="s in scans" :key="s.id">
          <uiImage :url="s.url" class="mr-3" />

          <div class="info">
            <div class="about">
              {{ scanSource(s) }}
              <br />
              {{ scanDate(s) }}
            </div>
            <div class="result" v-for="r in s.results" :key="r.id">
              {{ r.name }} {{ r.percent }}%
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API } from '@/config'
import { format, formatDistanceToNow } from 'date-fns'
import { ru } from 'date-fns/locale'

export default {
  name: 'UserSessions',
  props: {
    id: String
  },
  data () {
    return {
      loading: false,
      scans: []
    }
  },
  watch: {
    id () {
      this.scans = []
      this.load()
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      if (this.loading) return
      this.loading = true

      let { data } = await this.$http.post(API.USERS.scans, { id: this.id })
      if (!data || data.err) {
        this.$notify(data.err)
        return (this.loading = false)
      }

      this.scans = data.reverse()
      this.$emit('loaded', data.length)
      this.loading = false
    },
    scanDate (s) {
      return format(new Date(s.createdAt), 'dd.MM.yyyy в HH:mm')
    },
    scanSource (s) {
      if (s.source === 'addpet') return 'Добавить питомца'
      if (s.source === 'petscanner') return 'Петсканнер'
      return 'Неизвестно'
    },
    distance (d) {
      return formatDistanceToNow(new Date(d), { locale: ru })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.session {
  height: fit-content;
  margin-bottom: 10px;
  font-size: 13px;
}

.scan {
  display: flex;
  align-items: center;
  font-size: 14px;

  .about {
    font-size: 13px;
    opacity: 0.5;
    margin-bottom: 5px;
  }
}

.nope {
  text-align: center;
  padding: 10px 0;
  padding-bottom: 20px;
  opacity: 0.5;
}
</style>
